import react, { useEffect, useState } from "react";
import ComponentCard from "../../../../components/common/ComponentCard";
import Button from "../../../../components/ui/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "../../../../components/form/Form";
import Label from "../../../../components/form/Label";
import Select from "../../../../components/form/Select";
import Input from "../../../../components/form/input/InputField";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateTemperatureCheckItems() {
  const navigate = useNavigate();
  const location = useLocation();
  const item =location.state?.item;

  const [formData, setFormData] = useState({
    name:"",
    status: "",
    minimumTemperature:"",
    maximumTemperature: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    status: "",
    minimumTemperature: "",
    maximumTemperature: "",
  });

  useEffect(() => {
    if (item) {
      setFormData({
        name: item.name,
        status: item.status === 1 ? "Current" : "Non-Current",
        minimumTemperature: item.mintemp ,
        maximumTemperature: item.maxtemp,
      });
    }
  } , [item]);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,

    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const handleSelectChange = (option: any) => {
    setFormData({
      ...formData,
      status: option,
    });
    setErrors({
      ...errors,
      status: "",
    });
  };
  
  const validate = () => {
    let newErrors: any = {};
    if (!formData.name.trim()) newErrors.name = "Workflow Categories name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const token = localStorage.getItem("token");
      const payload = {
        actempcheck_id: item.actempcheck_id,
        name: formData.name,
        status: formData.status,
        minimumTemperature: formData.minimumTemperature,
        maximumTemperature: formData.maximumTemperature,
      };
      console.log(payload);

      const response = await fetch(`${apiUrl}/temperature_check_items`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        navigate("/temperature-check-items");
      }  
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const handleCancel = () => {
    navigate("/temperature-check-items");
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this workflow category?")) return;
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${apiUrl}/temperature_check_items/${item.actempcheck_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token || "",
          },
        }
      );
      if (response.ok) {
        navigate("/temperature-check-items");
      } else {
        console.error("Failed to delete temperature check item");
      }
    } catch (error) {
      console.error("Error deleting temperature check item:", error);
    }
  };
  
  return(
    <>
      <ComponentCard title="Update Temperature Check Item">
        <Form onSubmit={handleSubmit}>
          <>
            <div className="grid gap-6">
              <div className="col-span-full">
                <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                  Temperature Check Item
                </h4>
              </div>
              {/* Venue Area Name */}
              <div>
                <Label>Name</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
              </div>


              {/* Record Status */}
              <div>
                <Label>Record Status</Label>
                <Select
                  options={[
                    { value: "current", label: "Current" },
                    { value: "non-current", label: "Non-Current" },
                  ]}
                  value={formData.status}
                  onChange={handleSelectChange}
                  className="mt-2 bg-gray-50 dark:bg-gray-800"
                />
              </div>

              {/* Minimum Temperature */}
              <div>
                <Label>Minimum Temperature</Label>
                <Input
                  type="number"
                  id="minimumTemperature"
                  name="minimumTemperature"
                  value={formData.minimumTemperature}
                  onChange={handleChange}
                />
              </div>

              {/* Maximum Temperature */}
              <div>
                <Label>Maximum Temperature</Label>
                <Input
                  type="number"
                  id="maximumTemperature"
                  name="maximumTemperature"
                  value={formData.maximumTemperature}
                  onChange={handleChange}
                />
              </div>

              <div className="flex gap-3">
                <Button size="sm" type="submit">
                  Save Changes
                </Button>
                <Button size="sm" variant="outline" onClick={handleCancel} type="button">
                  Cancel
                </Button>
                <button className="px-4 py-3 text-sm font-medium text-white rounded-lg bg-error-800 shadow-theme-xs hover:bg-error-600" onClick={handleDelete}>
                  Delete
                </button>
              </div>
            </div>
          </>
        </Form>
      </ComponentCard>
    
    </>
  )
};